const CARD_WIDTH = 284;
const MARKER_WIDTH = 12;
const PADDING = 8;

export default ({
  mrkX,
  mrkY,
  mapW,
  mapH,
  cardContainerH,
  markerWidth = null,
}) => {
  const mWidth = markerWidth ? markerWidth / 2 : MARKER_WIDTH;

  let xCoords = mrkX + mWidth + PADDING;
  let yCoords = mrkY - cardContainerH / 2;
  let movedToTop = false;

  if (xCoords + CARD_WIDTH > mapW) {
    xCoords = mrkX - CARD_WIDTH - mWidth - PADDING;
  }

  if (yCoords < 0) {
    yCoords = mrkY + PADDING;

    if (yCoords + cardContainerH > mapH) {
      const diff = (yCoords + cardContainerH) - mapH;
      yCoords = yCoords - diff;
    }

    xCoords = mrkX - CARD_WIDTH / 2;
    if (xCoords < 0) {
      xCoords = mrkX + mWidth + PADDING;
    }
    if (xCoords + CARD_WIDTH > mapW) {
      xCoords = mrkX - CARD_WIDTH - mWidth - PADDING;
    }
    return {
      x: xCoords,
      y: yCoords,
    };
  }

  if (yCoords + cardContainerH > mapH) {
    movedToTop = true;
    yCoords = mrkY - 32 - PADDING - cardContainerH;

    if (yCoords < 0) {
      yCoords = PADDING;
    }

    xCoords = mrkX - CARD_WIDTH / 2;
    if (xCoords < 0) {
      xCoords = mrkX + mWidth + PADDING;
    }
    if (xCoords + CARD_WIDTH > mapW) {
      xCoords = mrkX - CARD_WIDTH - mWidth - PADDING;
    }
  }

  const res = {
    x: xCoords,
    y: yCoords,
    movedToTop,
  };

  return res;
};
